import React from "react";
import { FaCarrot, FaHeart, FaCalendarAlt, FaUtensils } from "react-icons/fa";

const styles = {
  section: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-start",
    justifyContent: "space-between",
    padding: "4rem 8%",
    backgroundColor: "#fff",
    fontFamily: "'Poppins', sans-serif",
  },
  left: {
    flex: "1",
    minWidth: "300px",
    marginBottom: "2rem",
  },
  subtitle: {
    color: "#f97316",
    fontWeight: "600",
    textTransform: "uppercase",
    marginBottom: "0.5rem",
    fontSize: "0.9rem",
  },
  heading: {
    fontSize: "2.2rem",
    fontWeight: "bold",
    lineHeight: "1.3",
    marginBottom: "1rem",
    marginTop: "5rem",
  },
  highlight: {
    color: "#f97316",

  },
  description: {
    fontSize: "1rem",
    color: "#555",
    lineHeight: "1.8",
    maxWidth: "500px",
    marginTop: "4rem",
  },
  right: {
    flex: "1",
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "1.5rem",
    minWidth: "300px",
  },
  card: {
    padding: "1.2rem",
    borderRadius: "0.75rem",
    backgroundColor: "#fff",
    boxShadow: "0 8px 20px 4px rgba(0,0,0,0.2)", 
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  cardOrange: {
    backgroundColor: "#f97316",
    color: "white",
  },
  icon: {
    fontSize: "1.5rem",
    marginBottom: "0.75rem",
  },
  cardTitle: {
    fontWeight: "600",
    marginBottom: "0.5rem",
  },
  cardText: {
    fontSize: "0.9rem",
    lineHeight: "1.4",
  },
};

export default function WhyChoose() {
  return (
    <section style={styles.section}>
      {/* Left side */}
      <div style={styles.left}>
        <p style={styles.subtitle}>OUR MENU</p>
        <h2 style={styles.heading}>
          Why Choose <span style={styles.highlight}>My Kitchen?</span>
        </h2>
        <p style={styles.description}>
          At My Kitchen, we take pride in delivering not just food, but an experience that reminds you of home.
          Handcrafted daily in our home kitchen, our tiffins bring you fresh, wholesome meals with ever-changing menus to delight your taste buds.
        </p>
      </div>

      {/* Right side */}
      <div style={styles.right}>
        <div style={styles.card}>
          <FaCarrot style={styles.icon} color="#f97316" />
          <h3 style={styles.cardTitle}>Veg/Non-Veg Options</h3>
          <p style={styles.cardText}>
            Choose from a variety of vegetarian and non-vegetarian dishes prepared with fresh ingredients.
          </p>
        </div>

        <div style={{ ...styles.card, ...styles.cardOrange }}>
          <FaHeart style={styles.icon} />
          <h3 style={styles.cardTitle}>Hygiene First</h3>
          <p style={styles.cardText}>
            We maintain the highest standards of cleanliness and food safety in our kitchen.
          </p>
        </div>

        <div style={{ ...styles.card, ...styles.cardOrange }}>
          <FaUtensils style={styles.icon} />
          <h3 style={styles.cardTitle}>Weekly Menu</h3>
          <p style={styles.cardText}>
            Enjoy different meals every day with our rotating weekly menu of authentic dishes.
          </p>
        </div>

        <div style={styles.card}>
          <FaCalendarAlt style={styles.icon} color="#f97316" />
          <h3 style={styles.cardTitle}>Local Delivery</h3>
          <p style={styles.cardText}>
            Convenient delivery service across Oshawa and surrounding areas.
          </p>
        </div>
      </div>
    </section>
  );
}